import searchService from "@/services/search.service"
import { classMapping, graduationMapping } from "@/helpers/mapping"

let ctx

export default function (context) {
    ctx = context
    return [
        {
            id: "welcome",
            next: "region",
            body: `Hey ${ctx.$auth.user?.trainee?.firstname}!
Ich bin Oabot.
Ich bin programmiert worden, um dir zu verraten, welche Berufe es für dich gibt und was deine Schule alles geplant hat.
Dafür brauche ich aber ein paar Infos von dir.`,
            noReply: true,
        },
        {
            id: "region",
            next: "class",
            body: "Woher kommst du? ",
            inputLabel: "Deine Region",
            inputType: "region",
            suggestions: async function () {
                let cities = await searchService
                    .getCities()
                    .catch((e) => console.warn(e))
                cities = cities.splice(0, 3).map((city) => ({
                    text: city.name,
                    value: city,
                    callback: async function () {
                        const loc = await searchService.getLocationFromSlug(
                            city.slug
                        )
                        const text = loc.name
                        ctx.currentMessage = text
                        ctx.setProgress(text, loc)
                        if (ctx.isEditMode) {
                            ctx.updateMessage(text)
                        } else {
                            ctx.sendMessage(text)
                        }
                    },
                }))
                cities.push({
                    text: "andere...",
                    callback: function () {
                        ctx.$refs.input?.openMenu()
                    },
                    animate: false,
                })
                return cities
            },
            defaultData: function () {
                const primaryAddress = ctx.$auth.user?.trainee?.primary_address
                if (!primaryAddress?.city) return
                return {
                    text: primaryAddress.city,
                    value: primaryAddress,
                }
            },
            hide: function () {
                return ctx.$auth.user?.trainee?.primary_address?.city
            },
        },
        {
            id: "class",
            next: "school",
            body: "In welche Jahrgangsstufe gehst du?",
            inputType: "number",
            inputLabel: "Wähle deine Klasse",
            options: [],
            suggestions: classMapping.slice(2),
            defaultData: function () {
                return ctx.$auth.user?.trainee?.class
            },
            hide: function () {
                return ctx.$auth.user?.trainee?.class
            },
            validator: (value) =>
                (Number(value) >= 5 && Number(value) <= 13) ||
                "Wähle eine Klasse zwischen 5 und 13",
        },
        {
            id: "school",
            next: "graduation",
            body: function () {
                if (ctx.formData.class.data == "-1") {
                    return "Auf welche Schule bist du gegangen?"
                }
                return "Auf welche Schule gehst du?"
            },
            inputLabel: "Deine Schule",
            inputType: "school",
            suggestions: async function () {
                const location = ctx.formData["region"]?.data
                if (!location) return
                let suggestions = await searchService
                    .searchBaseSchool({
                        limit: 4,
                        latitude: location.latitude ?? location.lat ?? null,
                        longitude: location.longitude ?? location.lng ?? null,
                    })
                    .catch((e) => {
                        console.warn(e)
                    })
                if (!suggestions?.length || suggestions.length == 0) return [] // empty result / error
                suggestions = suggestions.map((school) => ({
                    text: school.name,
                    value: school,
                }))
                suggestions.push({
                    text: "andere...",
                    callback: function () {
                        ctx.$refs.input?.openSearch()
                    },
                    animate: false,
                })
                return suggestions
            },
            defaultData: function () {
                return ctx.$auth.user?.trainee?.school_base?.name
            },
            hide: function () {
                return ctx.$auth.user?.trainee?.school_base?.name
            },
        },
        {
            id: "graduation",
            next: null,
            body: function () {
                if (ctx.formData.class.data == "-1") {
                    return "Welchen Schulabschluss hast du?"
                }
                return "Welchen Schulabschluss wirst du voraussichtlich haben?"
            },
            options: graduationMapping,
            inputType: "select",
            inputLabel: "Dein Schulabschluss",
            suggestions: function () {
                let graduationTypes = getGraduationSuggestions.call(ctx)
                graduationTypes.push({
                    text: "andere...",
                    callback: function () {
                        ctx.$refs.input?.openMenu()
                    },
                    animate: false,
                })
                return graduationTypes
            },
            defaultData: function () {
                let mapping = graduationMapping.find(
                    (graduation) =>
                        graduation.value ===
                        ctx.$auth.user?.trainee?.highest_graduation
                )
                if (mapping) {
                    return {
                        value: mapping.value,
                        text: mapping.text,
                    }
                }
                return undefined
            },
            hide: function () {
                return ctx.$auth.user?.trainee?.highest_graduation
            },
        },
    ]
}

function getGraduationSuggestions() {
    let suggestions = []
    const school = ctx.formData["school"].text.toLowerCase()
    if (school.includes("gymnasium")) {
        suggestions.push({
            text: "Abitur",
            value: "abi",
        })
        suggestions.push({
            text: "Bachelor",
            value: "bachelor",
        })
        suggestions.push({
            text: "Master",
            value: "master",
        })
    } else if (school.includes("berufs") || school.includes("fach")) {
        suggestions.push({
            text: "Fachabitur",
            value: "fos",
        })
        suggestions.push({
            text: "Abitur",
            value: "abi",
        })
        suggestions.push({
            text: "Bachelor",
            value: "bachelor",
        })
    } else {
        suggestions.push({
            text: "Mittlerer Schulabschluss",
            value: "mittel",
        })
        suggestions.push({
            text: "Qualifizierender Hauptschulabschluss",
            value: "quali",
        })
        suggestions.push({
            text: "Mittelschulabschluss",
            value: "main",
        })
    }
    return suggestions
}
